import React from 'react';
import { FadeIn } from './FadeIn';
import { motion } from 'framer-motion';
import { Check, Star } from 'lucide-react';
export function MainOffer() {
  const basic = {
    name: 'MegaPack',
    price: '$19.990',
    tagline: 'Para empezar a ordenar tu consulta.',
    features: ['MegaPack Nutri Infantil (6 tomos)', 'Recursos prácticos digitales', 'Acceso inmediato'],
    cta: 'Quiero el MegaPack',
    href: 'https://salud-en-tu-plato.myshopify.com/checkouts/cn/hWNBz6WXefL5OsxWXlXMPBbe/es-ar?_r=AQABLVxO1gBfGMFr4o7Au_9qaBiNEjChewgtQlb0njNICTk&cart_link_id=ph17KXnJ&preview_theme_id=151828791463'
  };
  const complete = {
    name: 'MegaPack + Láminas Pro',
    price: '$27.990',
    tagline: 'La opción más elegida y completa.',
    features: ['Todo lo del MegaPack', 'Láminas Pro imprimibles', '6 Bonos exclusivos GRATIS', 'Acceso inmediato'],
    cta: 'Quiero el pack completo',
    href: 'https://salud-en-tu-plato.myshopify.com/checkouts/cn/hWNBz6mtmyBzD6DgdvkIZ9ms/es-ar?_r=AQABaqLbdvExIDrBl4w56sQObk6WEI9yK3ZFYl3bfdkhYN4&cart_link_id=sLSKiCNr&preview_theme_id=151828791463'
  };
  return <section id="comprar" className="py-16 md:py-24 px-4 bg-black" data-id="element-144">
      <div className="max-w-4xl mx-auto" data-id="element-145">
        <FadeIn className="text-center mb-12" data-id="element-146">
          <span className="text-terracotta text-sm font-bold tracking-widest uppercase mb-3 block" data-id="element-147">
            Elegí tu opción
          </span>
          <h2 className="font-display text-3xl md:text-4xl font-bold text-cream" data-id="element-148">
            Dos formas de empezar hoy
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-5 md:gap-6 items-stretch" data-id="element-149">
          {/* BASIC */}
          <FadeIn delay={0.1} data-id="element-150">
            <div className="glow-beige bg-black rounded-2xl p-6 md:p-7 h-full flex flex-col" data-id="element-151">
              <div className="mb-5" data-id="element-152">
                <p className="text-cream/50 text-xs font-bold tracking-widest uppercase mb-2" data-id="element-153">
                  Básico
                </p>
                <h3 className="font-display text-xl font-bold text-cream mb-1" data-id="element-154">
                  {'MegaPack Nutri Infantil'}
                </h3>
                <p className="text-cream/60 text-sm" data-id="element-155">{basic.tagline}</p>
              </div>

              <div className="mb-6" data-id="element-156">
                <span className="font-display text-4xl font-bold text-cream" data-id="element-157">
                  {basic.price}
                </span>
                <span className="text-cream/50 text-sm ml-2" data-id="element-158">pago único</span>
              </div>

              <ul className="space-y-2.5 mb-6 flex-grow" data-id="element-159">
                {basic.features.map((f, i) => <li key={i} className="flex items-start gap-2 text-cream/80 text-sm" data-id="element-160">
                    <Check size={16} className="text-sand shrink-0 mt-0.5" data-id="element-161" />
                    <span data-id="element-162">{f}</span>
                  </li>)}
              </ul>

              <motion.a href={basic.href} target="_blank" rel="noopener noreferrer" whileHover={{
              scale: 1.02
            }} whileTap={{
              scale: 0.98
            }} className="block w-full bg-transparent border border-sand/40 hover:border-sand text-cream font-bold py-3 px-5 rounded-xl text-center text-sm uppercase tracking-wider transition-all" data-id="element-163">
                {basic.cta}
              </motion.a>
            </div>
          </FadeIn>

          {/* COMPLETE — most chosen */}
          <FadeIn delay={0.2} data-id="element-164">
            <div id="oferta-completa" className="relative h-full scroll-mt-24" data-id="element-165">
              {/* Floating badge */}
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 z-20" data-id="element-166">
                <div className="inline-flex items-center gap-1.5 bg-terracotta text-white text-[10px] md:text-xs font-bold px-3 py-1.5 rounded-full uppercase tracking-widest shadow-lg shadow-terracotta/40 whitespace-nowrap" data-id="element-167">
                  <Star size={12} className="fill-current" data-id="element-168" />
                  Más elegida
                </div>
              </div>

              <div className="glow-beige-pulse bg-black rounded-2xl p-6 md:p-7 h-full flex flex-col md:scale-[1.02]" data-id="element-169">
                <div className="mb-5" data-id="element-170">
                  <p className="text-sand text-xs font-bold tracking-widest uppercase mb-2" data-id="element-171">
                    Completa · Recomendada
                  </p>
                  <h3 className="font-display text-xl font-bold text-cream mb-1" data-id="element-172">
                    {'MegaPack Nutri Infantil+ L\xE1minas Pro'}
                  </h3>
                  <p className="text-cream/60 text-sm" data-id="element-173">{complete.tagline}</p>
                </div>

                <div className="mb-6 flex items-baseline gap-2" data-id="element-174">
                  <span className="font-display text-4xl font-bold text-cream" data-id="element-175">
                    {complete.price}
                  </span>
                  <span className="text-cream/50 text-sm line-through" data-id="element-176">
                    $147.960
                  </span>
                </div>

                <ul className="space-y-2.5 mb-6 flex-grow" data-id="element-177">
                  {complete.features.map((f, i) => <li key={i} className="flex items-start gap-2 text-cream/90 text-sm" data-id="element-178">
                      <Check size={16} className="text-sand shrink-0 mt-0.5" data-id="element-179" />
                      <span data-id="element-180">{f}</span>
                    </li>)}
                </ul>

                <motion.a href={complete.href} target="_blank" rel="noopener noreferrer" whileHover={{
                scale: 1.02
              }} whileTap={{
                scale: 0.98
              }} className="block w-full bg-terracotta hover:bg-terracottaDark text-white font-bold py-3 px-5 rounded-xl text-center text-sm uppercase tracking-wider shadow-lg shadow-terracotta/30 transition-all" data-id="element-181">
                  🚀 {complete.cta}
                </motion.a>
              </div>
            </div>
          </FadeIn>
        </div>

        <FadeIn delay={0.3} className="text-center mt-8" data-id="element-182">
          <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-cream/50 text-xs font-bold uppercase tracking-wider" data-id="element-183">
            <span data-id="element-184">⚡ Acceso inmediato</span>
            <span className="text-sand/30" data-id="element-185">•</span>
            <span data-id="element-186">💳 Un solo pago</span>
            <span className="text-sand/30" data-id="element-187">•</span>
            <span data-id="element-188">🛡️ Garantía 7 días</span>
          </div>
        </FadeIn>
      </div>
    </section>;
}